import { Image } from 'primereact/image';
import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import Layout from "../../../components/common/nav/initiator/nav.component";
import { groupBy, orderBy, range } from "lodash";
import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { InputSwitch } from "primereact/inputswitch";
import { DataTable } from 'primereact/datatable';
import { Auth, DataStore, Predicates, SortDirection } from 'aws-amplify';
import { ValidateInitiatorRole, } from '../../../helper/validateRole';
import { Column } from 'primereact/column';
import { Sidebar } from 'primereact/sidebar';
import { Tag } from 'primereact/tag';
import sideBarRight from "../../../assets/images/sidebarright.svg"
import user1 from "../../../assets/images/user1.svg"
import user2 from "../../../assets/images/user2.svg"
import Editpopup from "../../../components/popup/editpopup";
import { Dialog } from "primereact/dialog";
import Login from '../../../setup/auth/login.component';
import sidebar from "../../../assets/images/sidebarright.svg"
import { Dropdown } from 'primereact/dropdown';
import { TabView, TabPanel } from 'primereact/tabview';
import { Avatar } from 'primereact/avatar';
import { ConvertResponseForSelectWithRefCodedropdown, ConvertResponseForSelect } from '../../../helper/commonfunctions';
import {
  InitiateClassifiedWeeklyAbsenceReport, InitiateClassifiedWeeklyAbsenceReportStatus, Employee, Schools, Subject,
  SixthPeriodAssignmentInitiateReport, PSAConsultant,PSATransactionCycle
} from "../../../models";
import w9DetailesPic from '../../../assets/svg/w9details.svg'
import moment from "moment";
import { Link } from 'react-router-dom';
import AWS from "aws-sdk";
import awsmobile from "../../../aws-exports";
import { Calendar } from 'primereact/calendar';
import empDetailsImg from '../../../assets/images/applicationImg.png';
import { toast } from 'react-toastify';
import { Request_Status } from '../../../helper/enum';
import { reactLocalStorage } from 'reactjs-localstorage';
import HtmlToPdf from '../../../components/HtmlToPdf';
import ServiceAgreementPdf from '../../../components/reportpdftemplate/serviceagreementpdf';
import '../../../components/reportpdftemplate/base.min.css'
import '../../../components/reportpdftemplate/fancy.min.css'
import '../../../components/reportpdftemplate/main.css'
import PreviewAgreement from '../../../../src/assets/images/stipend-form.jpg';
import { FilterMatchMode, } from 'primereact/api';
import { useFormik } from "formik";
import PsaPdf from '../../../components/reportpdftemplate/personalserviceagreementpdf';
import PsaTermsAndConditions from '../../../components/personalserivicet&c';
import ReactFullscreen from 'react-easyfullscreen';



export default function ServiceAgreementPayrollReportList() {
  const [StipendsFormFullScreen, setStipendsFormFullScreen] = useState(false);
  const [RejectReport, setRejectReport] = useState(false);
  const [RejectReport_Send, setRejectReport_Send] = useState(false);
  const [Report_Approved, setReport_Approved] = useState(false);

  //states start
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [allEmployeeDetails, setAllEmployeeDetails] = useState([]);
  const [selectedEmployeeDetails, setSelectedEmployeeDetails] = useState(null);
  const [empCodeList, setEmpCodeList] = useState([]);
  const [specificReportDetailsView, setSpecificReportDetailsView] = useState([]);
  const [specificReportDetailsEdit, setSpecificReportDetailsEdit] = useState([]);
  const [submitCount, setSubmitCount] = useState(0);
  const [approvedCount, setApprovedCount] = useState(0);
  const [rejectCount, setRejectCount] = useState(0);
  const [initiatorReportList, setInitiatorReportList] = useState([]);
  
   const [approvalList, setApprovalList] = useState([]);
  //states end
  const [fullViewEdit, setFullViewEdit] = useState(false);
  const [fullViewForView, setFullViewForView] = useState(false);
  const [visibleCreteReportPopup, setVisibleCreteReportPopup] = useState(false);
  const [showNextPopUp, setShowNextPopUp] = useState(false);
  const [confirmVisible2, setConfirmVisible2] = useState(false);
  const [showPreviewPopUp, setShowPreviewPopUp] = useState(false);
  const [groupName, setGroupName] = useState();
  const [accountCharge, setAccountCharged] = useState('');
  const [totalStaffingAllocationectedRole, setTotalStaffingAllocation] = useState('');
  let [userList, setUserList] = useState([]);
  const [subjectCode, setSubjectCodeList] = useState(null);
  const [value, setValue] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  const [fteUtilized, setFteUtilized] = useState('');
  const [checked, setChecked] = useState(false);
  const [myaccountt, setProducts] = useState([]);
  const [isAuthenticated, userHasAuthenticated] = useState(true);
  const [visible, setVisible] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [position, setPosition] = useState('center');
  const [visibleRight, setVisibleRight] = useState(false);
  const [basicInfoPopUp, SetBasicInfoPopUp] = useState(true);
  const [weeklyAbsenceReports, setWeeklyAbsenceReports] = useState();
  const [weeklyAbsenceReportSubmitted, setWeeklyAbsenceReportSubmitted] = useState();
  const [weeklyAbsenceReportApproved, setWeeklyAbsenceReportApproved] = useState();
  const [weeklyAbsenceReportRejected, setWeeklyAbsenceReportRejected] = useState();
  const [weeklyAbsenceReportPending, setWeeklyAbsenceReportPending] = useState();
  const [activate, setActivate] = useState("");
  const [attchmentAndDetailes, SetAttchmentAndDetailes] = useState(false);
  const [termsAndConditions, SetTermsAndConditions] = useState(false);
  const [eddDetailes, SetEddDetailes] = useState(false);
  const [previewAndEdit, SetPreviewAndEdit] = useState(false);

  const [filters, setFilters] = useState({
    assignmentTitle: { value: null, matchMode: FilterMatchMode.CONTAINS },
    period: { value: null, matchMode: FilterMatchMode.CONTAINS },
    submittedOn: { value: null, matchMode: FilterMatchMode.CONTAINS },
    remark: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
  });

  const footerContent = (
    <div className='text-center'>
      <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { setConfirmVisible(false); setVisibleEdit(false) }}>Close</button>
    </div>
  );
  const footerContent1 = (
    <div className='text-center'>
      <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { setConfirmVisible2(false); setShowNextPopUp(false); setVisibleCreteReportPopup(false); setShowPreviewPopUp(false); }}>Close</button>
    </div>
  );
  //_____popup

  //*state
  const [reportId, setReportId] = useState('');
  const [schoolName, setSchoolName] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [status, setStatus] = useState('');
  const [schoolList, setSchoolList] = useState('');
  const [schoolSelect, setSelectedSchool] = useState('');
  const [partyDetailesPopup, setPartyDetailesPopUp] = useState(false);
const [budgetClerk, setBudgetClerk] = useState(null);
const [hrConsultant, setHrConsultant] = useState(null);

	const [executiveApprover, setExecutiveApprover] = useState(null);
	const [hrSecreatary, setHrSecreatary] = useState(null);
  //*List
  const [employeeList, setEmployeeList] = useState([]);
  const [reportEmployeeList, setReportEmployeeList] = useState([]);
  const [users, SetUsersList] = useState([]);
  const [absentCodeListDropdown, setSubjectListDropdown] = useState();
  const loggedUserId = reactLocalStorage.get('loggedUserId');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [assighnmentTitle, setAssighnmentTitle] = useState('');
  const [w9Detailes, SetW9Detailes] = useState(false);
  const [submittedTo, setSubmittedTo] = useState(null)
  const currentDateTime = moment();

const itemTemplate = (country) => {
    // Customize how the dropdown items are displayed
    return (
      <div>
        {country.name} - {country.code}
      </div>
    );
  };
  const [items, setItems] = useState([]);
const handleKeyUp = (event) => {
    const query = event.query;
	//console.log(event)
	
    let filteredData = empCodeList.filter((item) =>
      item.name.toLowerCase().includes(query.toLowerCase())
    );
	
	filteredData = filteredData.map(item => item.name)
	console.log(filteredData)
	setItems(filteredData)
    //setFilteredItems(filteredData);
  };

  const [statuses] = useState(['Approved', 'Pending', 'Rejected', 'Submitted', 'Reviewed And Resubmitted']);

  
  const initiatordata = [
    {
      srNo: '01',
      assignmentTitle: 'Tile01',
      period: '1',
      submittedOn: 'ON',
      remark: 'Yes'
    },
    {
      srNo: '01',
      assignmentTitle: 'Title02',
      period: '2',
      submittedOn: 'Yes',
      remark: 'No'
    },
  ]

  const TaskStatusSL = (product) => {
    switch (product.status) {
      case 'Reviewed & resubmitted':
        return 'info';

      case 'Rejected':
        return 'danger';

      case 'Pending':
        return 'warning';

      case 'Submitted':
        return 'info';

      case 'Approved':
        return 'success';

      case 'Approved (P)':
        return 'success';

      default:
        return null;
    }
  };

  const TaskStatusSLA = (product) => {
    return <Tag value={product.status} severity={TaskStatusSL(product)}></Tag>;
  };

  const statusItemTemplate = (option) => {
    return <Tag value={option} severity={TaskStatusSL(option)} />;
  };

  const [PSAview, setPSAview] = useState(false);
  const [PSAedit, setPSAedit] = useState(false);

  const [formData, setFormData] = useState({})
  const [department, setDepartment] = useState(null)

  const formik = useFormik({
    initialValues: {},
    validate: data => {
      let errors = {};
      return errors;
    },
    onSubmit: (data) => {
      console.log('data 👍👍👍👍', data)
      setFormData(data)
    }
  });
  const alljobactionContent = (row) => {
    return (
      <div className="flex justify-center w-full gap-2" >
        <div className='cursor-pointer' onClick={() => setPSAview(true)}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></div>
        <div className='cursor-pointer' onClick={() => setPSAedit(true)}><i className="gusd-edit text-[#667085] text-[20px] font-meduim"></i></div>


        {/* {
          row.status === "Submitted" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
            row.status === "Approved" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
              row.status === "Reviewed & resubmitted" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                <Link to='#' className="py-2 px-2.5"
                  onClick={() =>
                    onClickEditPopUp(row)
                  }><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
        } */}
      </div>
    );
  };
  
  
 

  //* onclick view popup
  const onClickViewPopup = async (requestData, position) => {
    setPosition(position);
    setVisible(true);

    //set Data for View Popup
    let obj = {
      employee_id: requestData.employee_id,
      assighment_at: requestData.assighment_at,
      from_date: requestData.from_date,
      to_date: requestData.to_date,
      subject_area: requestData.subject_area,
      total_staffing_allocation: requestData.total_staffing_allocation,
      account_charged: requestData.account_charged,
      current_fte_utilized: requestData.current_fte_utilized,
    }
    setSpecificReportDetailsView(obj);
  }



  const onClickEditPopUp = async (requestData) => {
    setVisibleEdit(true)

    //set Data for View Popup
    let obj = {
      employee_id: requestData.employee_id,
      assighment_at: requestData.assighment_at,
      from_date: requestData.from_date,
      to_date: requestData.to_date,
      subject_area: requestData.subject_area,
      total_staffing_allocation: requestData.total_staffing_allocation,
      account_charged: requestData.account_charged,
      current_fte_utilized: requestData.current_fte_utilized,
    }
    setSpecificReportDetailsEdit(obj);

  }

  const toggleActive = () => {
    setActivate(activate === "actives" ? "" : "actives");
  };

  async function onLoad() {
    try {
      await Auth.currentSession();
      if (!ValidateInitiatorRole()) { userHasAuthenticated(false); }
    } catch (e) {
      userHasAuthenticated(false);
    }
  }

  const saveBasicInfo = async (type) => {

    // if (selectedEmployee === null) { toast.error('Please Select Employee Id'); return; }
    // else if (schoolSelect === '') { toast.error('Please Select Assignment At'); return; }
    // else if (assighnmentTitle === '') { toast.error('Please enter Assighment Title'); return; }
    // else if (startDate === null) { toast.error('Please enter From Date'); return; }
    // else if (endDate === null) { toast.error('Please enter To Date'); return; }
    // else if (subjectCode === null) { toast.error('Please enter To Date'); return; }

    var updatedSchoolId;

    //Save Basic Info

    //check type
    console.log('formData 😂😂😂😂', formData)
    if (type === 'save') {
      // var newSixthPeriodAssignmentInitiateReport = await DataStore.save(new SixthPeriodAssignmentInitiateReport({
      //   "assignment_title": assighnmentTitle,
      //   "employee_id": selectedEmployee.name,
      //   "assighment_at": schoolSelect.name,
      //   "from_date": moment(startDate).format("YYYY-MM-DD"),
      //   "to_date": moment(endDate).format("YYYY-MM-DD"),
      //   "subject_area": subjectCode.name,
      //   "total_staffing_allocation": totalStaffingAllocationectedRole,
      //   "account_charged": accountCharge,
      //   "current_fte_utilized": fteUtilized,
      //   "status": Request_Status.P,
      // })
      // );
      console.log('formData.assighnmentTitle 👍👍👍👍👍', formData)
      console.log('formData.assighnmentTitle 👍👍👍👍👍', formData.assignmentTitle)
      var newPSAConsultant = await DataStore.save(new PSAConsultant(
        {
          assignmentTitle: formData.assignmentTitle,
          department: formData?.department?.code,
          amount: formData.amount,
          expireDate: formData.expireDate && moment(formData.expireDate).format("YYYY-MM-DD"),
          notifyDays: formData.notifyDays && moment(formData.notifyDays).format("YYYY-MM-DD"),
          accountNo: formData.accountNo,
          boardItem: formData.boardItem,
          services: formData.services,
          agreementDate: formData.agreementDate && moment(formData.agreementDate).format("YYYY-MM-DD"),
          effectiveDate: formData.effectiveDate && moment(formData.effectiveDate).format("YYYY-MM-DD"),
          reviewDate: formData.reviewDate && moment(formData.reviewDate).format("YYYY-MM-DD"),
          submittedTo: formData.submittedTo?.name,
          dateofboard: formData.dateofboard && moment(formData.dateofboard).format("YYYY-MM-DD"),
          pageItem: formData.pageItem,
          email: formData.email,
        }
      ))
      console.log("🚀 ~ file: index.js:299 ~ saveBasicInfo ~ newPSAConsultant: 👍👍👍👍👍👍", newPSAConsultant)
    } else {
      //other wise status submit
      var newSixthPeriodAssignmentInitiateReport = await DataStore.save(new SixthPeriodAssignmentInitiateReport({
        "assignment_title": assighnmentTitle,
        "employee_id": selectedEmployee.name,
        "assighment_at": schoolSelect.name,
        "from_date": moment(startDate).format("YYYY-MM-DD"),
        "to_date": moment(endDate).format("YYYY-MM-DD"),
        "subject_area": subjectCode.name,
        "total_staffing_allocation": totalStaffingAllocationectedRole,
        "account_charged": accountCharge,
        "current_fte_utilized": fteUtilized,
        "submited_by": loggedUserId,
        "submited_at": moment(currentDateTime).format("YYYY-DD-MM"),
        "status": Request_Status.S,
      })
      );
    }

    // updatedSchoolId = newSixthPeriodAssignmentInitiateReport.id;

    if (newPSAConsultant) {
      toast.success('Data Added Successfully.');
      BindList();
    }
  }

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
    region: process.env.REACT_APP_AWS_Region,
  });


  //*get getEmployeeResponse
  const getEmployeeResponse = (id) => {
    let _employeeList = [...employeeList];
    var returnRecord = _employeeList.find(o => o.id === String(id));
    if (returnRecord !== null && returnRecord !== undefined) { return returnRecord; } else { return null; }
  }


  //Get PSAConsultant List
  const BindList = async () => {
		
		//Approver
		 try {
		//2.fetch those request which needs approval for logged users.
      let PSAConsultantTransactionCycleResponse = await DataStore.query(
        PSATransactionCycle,
        c => c.to_Employee_Id.eq(loggedUserId),
        { sort: s => s.createdAt(SortDirection.DESCENDING) }
      );
      console.log("PSAConsultantTransactionCycleResponse:-", PSAConsultantTransactionCycleResponse);
      PSAConsultantTransactionCycleResponse = groupBy(PSAConsultantTransactionCycleResponse, "report_Id");

      if (PSAConsultantTransactionCycleResponse) {
        let pendingCount = 0;
        let approvedCount = 0;
        let rejectCount = 0;
        let approvalFinalData = [];
        let i = 0;
        // for (let i = 0; i < sixthPeriodReportTransactionCycleResponse.length; i++) {
        for (let report_Id in PSAConsultantTransactionCycleResponse) {
          const currentItem = PSAConsultantTransactionCycleResponse[report_Id][0];

          //get Report data using report id
      PSAConsultantTransactionCycleResponse = groupBy(PSAConsultantTransactionCycleResponse, "report_Id");
          const PSAConsultantTransactionCycleResponse = await DataStore.query(PSAConsultant, c =>
            c.id.eq(report_Id)
          );
		  
		  let obj = {
            srNo: i + 1,
            assignmentTitle: PSAConsultantTransactionCycleResponse[0].assignmentTitle ? PSAConsultantTransactionCycleResponse[0].assignmentTitle : '',
            // period: '',
            submittedOn: PSAConsultantTransactionCycleResponse[0].createdAt ? moment(PSAConsultantTransactionCycleResponse[0].createdAt).format("MM/DD/YYYY") : '',
            remark: PSAConsultantTransactionCycleResponse[0].otherRemark ? PSAConsultantTransactionCycleResponse[0].otherRemark : '',
          }

          approvalFinalData.push(obj);
		  
		}
		
		setApprovalList(approvalFinalData)
		
		}
		
	  
		
      
    } catch (error) {
      console.log('Error for bindList', error);
    }


    var SubjectCodeResponses = await DataStore.query(Subject, Predicates.ALL, {
      sort: s => s.name(SortDirection.ASCENDING)
    });
    setSubjectCodeList(SubjectCodeResponses)
    var myArray = []; myArray = ConvertResponseForSelectWithRefCodedropdown(SubjectCodeResponses); setSubjectListDropdown(myArray);


    var SchoolResponses = await DataStore.query(Schools, Predicates.ALL, {
      sort: s => s.name(SortDirection.ASCENDING)
    });
    var schoolArray = []; schoolArray = ConvertResponseForSelect(SchoolResponses); setSchoolList(schoolArray);


    var employeeList = await DataStore.query(Employee, Predicates.ALL, {
      sort: s => s.employee_name(SortDirection.ASCENDING)
    });
    setEmployeeList(employeeList)

    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params =
    {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 60
    };
    cognito.listUsers(params, (err, data) => {
      if (err) {
        console.log(err);
      } else {
        // console.log(data)
        SetUsersList(data.Users);
      }
    });

    //loadAbsenceReport();
  }
  //*loadAbsenceReport
  const loadAbsenceReport = async () => {

    //*Set Weekly Absence Report-Classified List
    var weeklyAbsenceReport = await DataStore.query(InitiateClassifiedWeeklyAbsenceReport)
    let newResponse = [];
    for (let i = 0; i < weeklyAbsenceReport.length; i++) {
      let schoolName = "";
      let workDuration = "";
      let submittedOn = "";
      let status = "";
      let remark = "";

      //*Work Duration
      if (weeklyAbsenceReport[i].from_date && weeklyAbsenceReport[i].to_date) {
        let fromDate = moment(weeklyAbsenceReport[i].from_date, 'YYYY-DD-MM').format('Do');
        let toDate = moment(weeklyAbsenceReport[i].to_date, 'YYYY-DD-MM').format("Do MMMM'YY");
        workDuration = fromDate + " - " + toDate
      }
      else { workDuration = "-" }

      //*submitted On
      if (weeklyAbsenceReport[i].status_date_time !== null && weeklyAbsenceReport[i].status_date_time !== undefined) {
        submittedOn = weeklyAbsenceReport[i].status_date_time !== null ? moment(weeklyAbsenceReport[i].status_date_time).format("Do MMMM'YY") : "-";
      } else { submittedOn = "-" }

      // //*School Name
      if (weeklyAbsenceReport[i].school_id !== null && weeklyAbsenceReport[i].school_id !== undefined) {
        var schoolResponses = await DataStore.query(Schools, (c) => c.id.eq(weeklyAbsenceReport[i].school_id));
        if (schoolResponses.length > 0) { schoolName = schoolResponses[0].name; } else { schoolName = ""; }
      } else { schoolName = ""; }

      if (weeklyAbsenceReport[i].payroll_status !== null && weeklyAbsenceReport[i].payroll_status === InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_ACCEPTED) {
        status = "Approved (P)"; remark = "-";
      } else if (weeklyAbsenceReport[i].payroll_status !== null && weeklyAbsenceReport[i].payroll_status === InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_REJECTED) {
        status = "Rejected (P)"; remark = weeklyAbsenceReport[i].payroll_remark;
      } else if (weeklyAbsenceReport[i].approver_status !== null && weeklyAbsenceReport[i].approver_status === InitiateClassifiedWeeklyAbsenceReportStatus.APPROVAL_ACCEPTED) {
        status = "Approved (A)"; remark = "-";
      } else if (weeklyAbsenceReport[i].approver_status !== null && weeklyAbsenceReport[i].approver_status === InitiateClassifiedWeeklyAbsenceReportStatus.APPROVAL_REJECTED) {
        status = "Rejected (A)"; remark = weeklyAbsenceReport[i].approver_remark;
      } else if (weeklyAbsenceReport[i].payroll_status === null && weeklyAbsenceReport[i].approver_status === null && weeklyAbsenceReport[i].status === InitiateClassifiedWeeklyAbsenceReportStatus.SUBMITTED) {
        status = "Submitted"; remark = "-";
      } else if (weeklyAbsenceReport[i].payroll_status === null && weeklyAbsenceReport[i].approver_status === null && weeklyAbsenceReport[i].status === InitiateClassifiedWeeklyAbsenceReportStatus.OPEN) {
        status = "Pending"; remark = "-";
      }

      newResponse.push({
        "id": weeklyAbsenceReport[i].id,
        "user_id": weeklyAbsenceReport[i].user_id, "status": status, "school_id": weeklyAbsenceReport[i].school_id, "from_date": weeklyAbsenceReport[i].from_date,
        "to_date": weeklyAbsenceReport[i].to_date, "status_date_time": weeklyAbsenceReport[i].status_date_time, "approver_remark": weeklyAbsenceReport[i].approver_remark, "payroll_remark": weeklyAbsenceReport[i].payroll_remark !== null ? weeklyAbsenceReport[i].payroll_remark : "-",
        "schoolName": schoolName, "workDuration": workDuration, "submittedOn": submittedOn, "remark": remark, "createdAt": weeklyAbsenceReport[i].createdAt, "updatedAt": weeklyAbsenceReport[i].updatedAt,
      })

      if (i === weeklyAbsenceReport.length - 1) {

        setWeeklyAbsenceReports(newResponse)
        //SubmittedCount
        const submittedCount = newResponse.filter(obj => obj.status === "Submitted")
        setWeeklyAbsenceReportSubmitted(submittedCount.length)

        //SubmittedCount
        const approvedCountP = newResponse.filter((obj) => obj.status === "Approved (P)");
        const approvedCountA = newResponse.filter((obj) => obj.status === "Approved (A)");
        let approvedCount = approvedCountP.length + approvedCountA.length
        setWeeklyAbsenceReportApproved(approvedCount)

        //RejectedCount
        const rejectedCountP = newResponse.filter((obj) => obj.status === "Rejected (P)");
        const rejectedCountA = newResponse.filter((obj) => obj.status === "Rejected (A)");
        const rejectedCount = rejectedCountP.length + rejectedCountA.length
        setWeeklyAbsenceReportRejected(rejectedCount)

        //RejectedCount
        const pendingCount = newResponse.filter((obj) => obj.status === "Pending");
        setWeeklyAbsenceReportPending(pendingCount.length)
      }
    }
  }

  useEffect(() => {
    // onLoad();
    BindList();
  }, []);

  const statusRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterApplyCallback(e.value)} itemTemplate={statusItemTemplate} placeholder="Select" className="p-column-filter custDropdown" showClear style={{ minWidth: '7rem' }} />
    );
  };



  return isAuthenticated ? (
    <>
    <ReactFullscreen>
        {({ onToggle }) => (
      <Layout pageTitle="Report" activeMenu="Initiator">
        <div className="report-wrapper pt-24 md:pt-28 xl:pt-[2.083vw]">
          <div className="flex justify-end visible lg:hidden">
            <Button icon="pi pi-bars" onClick={toggleActive} style={{ color: '#308B90', background: '#ffffff00', border: '1', borderColor: '#308B90', width: '38px', padding: '6px 0', borderRadius: '4px' }}></Button>

          </div>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-3 xl:gap-[1.250vw] pb-5">
            <div className="relative z-10 col-span-12" data-aos="fade-down" data-aos-duration="800">
              <div className="bg-[#fff] box-shadow-2 radius8 border border-[#E4E7EC]" >
                <div className="flex items-center justify-between p-[20px] xl:px-[1.250vw] xl:py-[0.990vw] border-b border-[#E4E7EC] ">
                  <p className="text-[22px] xl:text-[0.938vw]  text-[#101828] font-medium">Personal Service Agreement</p>

                  <div className="flex gap-2 xl:gap-[0.990vw] items-center">
                      <Link to="" onClick={() => {
                          onToggle();
                        }}> <i className="gusd-expand"></i></Link>
                  </div>
                </div>

                <div>
                  {/* <TabView> */}
                    
                    {/* <TabPanel header="Requested Reports"> */}
                      <div className="initiator">
                        <DataTable className="custpaginator custIcons custmBtnTable custTable" scrollable
                          filters={filters}
                          filterDisplay="row"
                          value={approvalList}
                          // value={initiatordata}
                          paginator responsiveLayout="scroll" paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={11}>
                          <Column field="srNo" header="SL#" sortable style={{ minWidth: '3rem' }}></Column>
                          <Column field="assignmentTitle" filters header="Assignment Title" sortable filter filterPlaceholder="Search" style={{ minWidth: '5rem' }}></Column>
                          {/* <Column field="period" filters header="Period" sortable filter filterPlaceholder='Search'></Column> */}
                          <Column field="submittedOn" filters header="Submitted On" sortable filter filterPlaceholder="Search" style={{ minWidth: '5rem' }}></Column>
                          <Column field="status" header="Status" body={TaskStatusSLA} filter filterElement={statusRowFilterTemplate} sortable style={{ minWidth: '8rem' }}></Column>
                          <Column field="remark"  header="Remarks" align='center' sortable style={{ minWidth: '6rem' }}></Column>
                          <Column field="action" header="Action" frozen alignFrozen="right" align='center' body={alljobactionContent} style={{ minWidth: '6rem' }}></Column>
                        </DataTable>
                      </div>
                    {/*</TabPanel> */}
                  {/* </TabView> */}
                </div>         



                <Dialog className="relative reports-popup" visible={visible} position={position}
                  style={{ width: '80vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisible(false)} draggable={false} resizable={false}>
                  <div className="grid grid-cols-1 lg:grid-cols-12">
                    <div className="col-span-1 lg:col-span-8 bg-[#F5F6F7] h-auto">
                      <div className="p-5">
                        <div onClick={() => setVisible(false)} className="py-3">
                          <Image src={sideBarRight} alt="user" width="24" height="24" /></div>

                        {
                          (!fullViewForView) ?
                            <div className=''>
                              <div className='text-center'>
                                <div className="text-[#000000] text-md lg:text-[0.833vw] font-bold">GLENDALE UNIFIED SCHOOL DISTRICT</div>
                                <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Request For Approval - Sixth Period Teaching Assignment</div>
                              </div>

                              <div className='pt-3'>
                                <p>Approval Status</p>
                                <div className="py-3 emp-simple-tbl">
                                  <DataTable
                                    value={[
                                      {
                                        id: '1000',
                                        title: 'Principal',
                                        name: 'Alrick Barwa',
                                        status: 'Approved'
                                      },
                                      {
                                        id: '1001',
                                        title: 'Teacher',
                                        name: 'John Mishra',
                                        status: 'Approved'
                                      },
                                      {
                                        id: '1002',
                                        title: 'EAFE Program Administrator',
                                        name: 'Alrick Barwa',
                                        status: 'Approved'
                                      }

                                    ]}>
                                    <Column field="title" header="Title"></Column>
                                    <Column field="name" header="Name"></Column>
                                    <Column field="status" header="Status"></Column>
                                  </DataTable>
                                </div>
                              </div>

                            </div>

                            : null
                        }


                        <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">

                          <div className='flex justify-between'>
                            <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-file-icon"></i>Sixth Period Teaching Assignment.pdf</div>
                            <button onClick={() => { (!fullViewForView) ? setFullViewForView(true) : setFullViewForView(false) }} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>{(!fullViewForView) ? 'View Full Screen' : 'Exit Full Screen'} </button>
                          </div>

                          <div className="grid grid-cols-1">
                            {/* <img src={pdfImage} alt='myImg' /> */}
                            {/* <HtmlToPdf
                              data={{
                                'employeeName': 'Abc',
                                'employeeId': selectedEmployee.name,
                                'schoolName': schoolSelect.name,
                                'dateFrom': moment(startDate).format("YYYY-DD-MM"),
                                'dateTo': moment(endDate).format("YYYY-DD-MM"),
                                'subjectName': subjectCode.name,
                                'staffAllocation': totalStaffingAllocationectedRole,
                                'accountCharged': accountCharge,
                                'fteUtilized': fteUtilized
                              }}
                            /> */}
                            <PsaPdf
                              data={{
                                'employeeName': 'Abc',
                                'employeeId': "Siddhesh",
                                'schoolName': "Privte Highschool",
                                'dateFrom': moment().format("YYYY-DD-MM"),
                                'dateTo': moment().format("YYYY-DD-MM"),
                                'subjectName': "Marathi",
                                'staffAllocation': "023",
                                'accountCharged': "accountCharge",
                                'fteUtilized': "fteUtilized"
                              }}
                            />
                          </div>
                        </div>




                        <div className='grid grid-cols-2 gap-4'>
                          <div className="bg-white border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                            <i className="mr-3 gusd-print-outline"></i><span>Print</span>
                          </div>

                          <div className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                            <i className="mr-3 gusd-print-outline"></i><span>Download</span>
                          </div>
                        </div>


                      </div>
                    </div>
                    <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">
                      <div className="p-5">
                        <div className="text-[#344054] text-[16px] font-medium py-3">Form History</div>
                        <div>
                          <div className="text-[#000000] text-[12px] font-normal text-center py-2 separator">Yesterday</div>
                          <div className="flex items-start justify-between gap-2 py-2">
                            <Image src={user1} alt="user" width="32" height="32" />
                            <div className="">
                              <div className="flex justify-between">
                                <div>
                                  <div className="text-[#344054] font-semibold text-[14px]">Jhon Paul</div>
                                  <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                    <i className="mr-1 gusd-commented"></i>
                                    <span>Commented on parties Tab</span>
                                  </div>
                                </div>
                                <div className="text-[#344054] text-[12px]">09:00</div>
                              </div>
                              <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">changed the input name of employee from “Kalvin” to “Samston”.</div>
                            </div>
                          </div>
                          <div className="flex items-start justify-between gap-2 py-2">
                            <Image src={user2} alt="user" width="32" height="32" />
                            <div className="">
                              <div className="flex justify-between">
                                <div>
                                  <div className="text-[#344054] font-semibold text-[14px]">Jhoana Maria</div>
                                  <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                    <i className="mr-1 gusd-commented"></i>
                                    <span>Commented on parties Tab</span>
                                  </div>
                                </div>
                                <div className="text-[#344054] text-[12px]">09:00</div>
                              </div>
                              <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">changed the input name of employee from “Kalvin” to “Samston”.</div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="text-[#000000] text-[12px] font-normal text-center py-2 separator">April 7h</div>
                          <div className="flex items-start justify-between gap-2 py-2">
                            <Image src="/assets/images/user3.svg" alt="user" width="32" height="32" />
                            <div className="">
                              <div className="flex justify-between">
                                <div>
                                  <div className="text-[#344054] font-semibold text-[14px]">Jennifer Lopez</div>
                                  <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                    <i className="mr-1 gusd-commented"></i>
                                    <span>Commented on parties Tab</span>
                                  </div>
                                </div>
                                <div className="text-[#344054] text-[12px]">09:00</div>
                              </div>
                              <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">changed the input name of employee from “Kalvin” to “Samston”.</div>
                            </div>
                          </div>
                          <div className="flex items-start justify-between gap-2 py-2">
                            <Image src="/assets/images/user4.svg" alt="user" width="32" height="32" />
                            <div className="">
                              <div className="flex justify-between">
                                <div>
                                  <div className="text-[#344054] font-semibold text-[14px]">Lethicia Jhansen</div>
                                  <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                    <i className="mr-1 gusd-commented"></i>
                                    <span>Commented on parties Tab</span>
                                  </div>
                                </div>
                                <div className="text-[#344054] text-[12px]">09:00</div>
                              </div>
                              <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">changed the input name of employee from “Kalvin” to “Samston”.</div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="text-[#000000] text-[12px] font-normal text-center py-2 separator">April 7h</div>
                          <div className="flex items-start justify-between gap-2 py-2">
                            <Image src="/assets/images/user5.svg" alt="user" width="32" height="32" />
                            <div className="">
                              <div className="flex justify-between">
                                <div>
                                  <div className="text-[#344054] font-semibold text-[14px]">Jhon Doe</div>
                                  <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                    <i className="mr-1 gusd-commented"></i>
                                    <span>Commented on parties Tab</span>
                                  </div>
                                </div>
                                <div className="text-[#344054] text-[12px]">09:00</div>
                              </div>
                              <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">changed the input name of employee from “Kalvin” to “Samston”.</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Dialog>

                {/* edit popup start */}
                < Dialog className="relative reports-popup" visible={visibleEdit} position="right" style={{ width: `${(fullViewEdit) ? '50vw' : '30vw'}` }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleEdit(false)} draggable={false} resizable={false} >
                  <div className="">
                    <div className="bg-[#F5F6F7] relative h-screen">
                      <div className="p-5">
                        <a to='' onClick={() => setVisibleEdit(false)} className="py-3"><Image
                          src={sidebar} alt="user" width="24" height="24" /></a>


                        {
                          (!fullViewEdit) ?
                            <div>
                              <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">Personal Service Agreement</div>
                              <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Sixth Period Teaching Assignment - Classified form</div>
                              <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                <div className="mb-1">
                                  <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">Approval Status</label>
                                  <div className="py-3 emp-simple-tbl">
                                    <DataTable
                                      value={[
                                        {
                                          id: '1000',
                                          title: 'Principal',
                                          name: 'Alrick Barwa',
                                          status: 'Approved'
                                        },
                                        {
                                          id: '1001',
                                          title: 'Teacher',
                                          name: 'John Mishra',
                                          status: 'Approved'
                                        },
                                        {
                                          id: '1002',
                                          title: 'EAFE Program Administrator',
                                          name: 'Alrick Barwa',
                                          status: 'Approved'
                                        }

                                      ]}>
                                      <Column field="title" header="Title"></Column>
                                      <Column field="name" header="Name"></Column>
                                      <Column field="status" header="Status"></Column>
                                    </DataTable>
                                  </div>
                                </div>
                              </div>
                            </div> : null
                        }



                        <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">

                          {
                            (!fullViewEdit) ?
                              <div className='flex justify-between'>
                                <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Sixth Period.pdf</div>
                                <button onClick={() => setFullViewEdit(true)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>View Full Screen</button>
                              </div> :
                              <div className='flex justify-between'>
                                <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Sixth Period Teaching Assignment.pdf</div>
                                <button onClick={() => setFullViewEdit(false)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>Exit Full Screen</button>
                              </div>
                          }

                          {
                            (!fullViewEdit) ?
                              <div className="grid grid-cols-1 border border-[red] h-80 overflow-hidden">
                                {/* <img src={pdfImageForEdit} alt='myImg' /> */}
                                <HtmlToPdf
                                  data={{
                                    'employeeName': 'Abc',
                                    'employeeId': specificReportDetailsEdit.employee_id,
                                    'schoolName': specificReportDetailsEdit.assighment_at,
                                    'dateFrom': specificReportDetailsEdit.from_date,
                                    'dateTo': specificReportDetailsEdit.to_date,
                                    'subjectName': specificReportDetailsEdit.subject_area,
                                    'staffAllocation': specificReportDetailsEdit.total_staffing_allocation,
                                    'accountCharged': specificReportDetailsEdit.account_charged,
                                    'fteUtilized': specificReportDetailsEdit.current_fte_utilized
                                  }}
                                />
                              </div> :
                              <div className='mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw] overflow-y-auto' style={{ height: '580px' }}>
                                {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                                <HtmlToPdf
                                  data={{
                                    'employeeName': 'Abc',
                                    'employeeId': specificReportDetailsEdit.employee_id,
                                    'schoolName': specificReportDetailsEdit.assighment_at,
                                    'dateFrom': specificReportDetailsEdit.from_date,
                                    'dateTo': specificReportDetailsEdit.to_date,
                                    'subjectName': specificReportDetailsEdit.subject_area,
                                    'staffAllocation': specificReportDetailsEdit.total_staffing_allocation,
                                    'accountCharged': specificReportDetailsEdit.account_charged,
                                    'fteUtilized': specificReportDetailsEdit.current_fte_utilized
                                  }}
                                />
                              </div>
                          }
                        </div>
                      </div>



                      <div className="absolute  bottom-2 left-2 right-2 grid grid-cols-2 gap-2 ">

                        <Link to='#' className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                          //  onClick={() => setVisibleCreteReportPopup(false)}
                          onClick={() => setConfirmVisible(true)}
                        ><i className="pi pi-save mr-1" style={{ fontSize: '1rem' }}></i>Save</Link>

                        <Link to='' className=" text-center flex items-center tableBtn blue radius8"
                          //  onClick={() => saveGroupInfo()}
                          onClick={() => setConfirmVisible(true)}
                        ><i className="pi pi-check mr-1" style={{ fontSize: '1rem' }}></i>Submit</Link>

                      </div>
                    </div>
                  </div>
                </Dialog>

                {/* confirmation dialog */}

                <Dialog header="" visible={confirmVisible} style={{ width: '30vw' }} onHide={() => { setConfirmVisible(false); setVisibleEdit(false); }} footer={footerContent}>
                  <p className="m-0 text-[#0487C8]">
                    <i className='pi pi-check-circle mr-2'></i>
                    <span className='font-medium text-[18px]'>Your changes has been saved in this report</span>
                  </p>
                </Dialog>
                {/* edit popup end */}

              </div>

              <Sidebar visible={visibleRight} position="right" onHide={() =>
                setVisibleRight(false)} style={{ width: '35vw' }} className="customesidebar1 responsivepoup">
                <Editpopup popupstate={() => setVisibleRight(false)}
                  fromDate={fromDate}
                  toDate={toDate}
                  schoolName={schoolName}
                  reportEmployeeList={reportEmployeeList}
                  status={status}
                  reportId={reportId}
                  bindList={() => loadAbsenceReport()}
                  type={"Initior"}
                />

              </Sidebar>
            </div>
          </div>
        </div>


        {/* popup's */}
        <Dialog className="relative reports-popup" visible={visibleCreteReportPopup} position="right" style={{ width: '30vw' }
        } breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleCreteReportPopup(false)} draggable={false} resizable={false} >
          <div className="">
            <div className="bg-[#F5F6F7] relative h-screen">
              <div className="p-5">
                <a to='' onClick={() => setVisibleCreteReportPopup(false)} className="py-3"><Image
                  src={sidebar} alt="user" width="24" height="24" /></a>
                <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">Personal Service Agreement</div>
                {/* <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Roles</div> */}
                <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                  <div className="mb-1">
                    <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">Assignment Title</label>
                    <div><InputText
                      value={groupName}
                      onChange={e => setGroupName(e.target.value)}
                      id="username" placeholder="Type Here" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" /></div>
                  </div>
                </div>
              </div>
              <div className="absolute  bottom-2 left-2 right-2 grid grid-cols-2 gap-2 ">

                <Link to='#' className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center" onClick={() => setVisibleCreteReportPopup(false)}><i className="pi pi-times mr-1" style={{ fontSize: '1rem' }}></i>Cancel</Link>

                <Link to='' className=" text-center flex items-center tableBtn blue radius8" onClick={() => {
                  setShowNextPopUp(true);
                  // saveGroupInfo();
                }}><i className="pi pi-arrow-right mr-1" style={{ fontSize: '1rem' }}></i>Next</Link>

              </div>
            </div>
          </div>
        </Dialog>
        <Sidebar className='PSAviewPopup' visible={PSAview} position="right" onHide={() => setPSAview(false)} style={{ width: '60vw', background: '#F5F6F7' }}>
          <div className='xl:py-[1.667vw] py-[28px] xl:px-[1.250vw] px-[20px]'>
            <div className='cursor-pointer mb-[20px]' onClick={() => setPSAview(false)}><Image src={sideBarRight} alt="user" width="20" height="20" /></div>

            <div className='text-black font-bold xl:text-[1.406vw] text-[25px]'>GLENDALE UNIFIED SCHOOL DISTRICT</div>
            <div className='text-black font-normal xl:text-[0.938vw] text-[16px]'>Request For Approval - Personal Service Agreement</div>

            <div className='xl:p-[1.250vw] p-[20px] bg-[#F5F6F7] flex items-center justify-between mt-[20px]'>
              <div className='flex items-center space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]'>
                <span className='gusd-file-icon w-4 h-4 inline-block'></span><span>Personal Service Agreement.pdf</span>
              </div>
            </div>

            <div className='xl:p-[1.250vw] p-[20px] bg-[#F5F5F5] rounded-bl rounded-br'>
              <div className='lg:h-[25vw] h-[450px] overflow-auto'>
                <PsaPdf
                  data={{
                    'employeeName': 'Abc',
                    'employeeId': "Siddhesh",
                    'schoolName': "Privte Highschool",
                    'dateFrom': moment().format("YYYY-DD-MM"),
                    'dateTo': moment().format("YYYY-DD-MM"),
                    'subjectName': "Marathi",
                    'staffAllocation': "023",
                    'accountCharged': "accountCharge",
                    'fteUtilized': "fteUtilized"
                  }}
                />

              </div>
            </div>

            <div className='grid grid-cols-2 mt-[20px] gap-[14px]'>
              <div><Link to={''} className='text-[#344054] font-medium text-xs xl:text-[0.833vw] bg-white border border-[#D0D5DD] text-center flex items-center justify-center gap-x-2 xl:py-[0.521vw] py-[6px] xl:px-[0.833vw] px-[12px] rounded-lg'><i className='gusd-print-outline'></i><span>Print</span></Link></div>
              <div><Link to={''} className='text-[#FFFFFF] font-medium text-xs xl:text-[0.833vw] bg-[#113699] border border-[#113699] text-center flex items-center justify-center gap-x-2 xl:py-[0.521vw] py-[6px] xl:px-[0.833vw] px-[12px] rounded-lg'><i className='Download_WhiteIcon'></i><span>Download</span></Link></div>
            </div>

          </div>
        </Sidebar>


        <Sidebar className='PSAviewPopup' visible={PSAedit} position="right" onHide={() => setPSAedit(false)} style={{ width: '35vw', background: '#F5F6F7' }}>
          <div className='xl:py-[1.667vw] py-[28px] xl:px-[1.250vw] px-[20px] lg:space-y-[1.250vw] space-y-2'>
            {/*col*/}
            <div className='cursor-pointer mb-[20px]' onClick={() => setPSAedit(false)}><i className='gusd-close-sidebar'></i></div>
            {/*col*/}
            <div>
              <div className='text-[#113699] font-semibold text-sm xl:text-[0.938vw]'>Glendale Unified School District</div>
              <div className='text-[#344054] font-normal text-xs xl:text-[0.677vw]'>Personal Service Agreement </div>
            </div>
            {/*col*/}
            <div className='bg-[#EFF0F1] p-4 xl:p-[0.885vw]'>
              <div className='text-[#344054] font-semibold text-xs xl:text-[0.677vw]'>Approval Status</div>
              <div className='bg-white p-2 xl:p-[0.469vw] rounded-lg mt-[8px]'>
                <table class="table-auto w-full">
                  <thead>
                    <tr className='text-[#667085] text-xs py-2 px-2 inline-block'>
                      <th align='left' width={200} className='font-medium'>Title</th>
                      <th align='left' width={130} className='font-medium'>Name</th>
                      <th align='left' width={150} className='font-medium'>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className='text-[#344054] text-xs font-normal py-2 px-2 inline-block border-b border-[#E4E7EC]'>
                      <td align='left' width={200}>Principal</td>
                      <td align='left' width={130}>Alrick Barwa</td>
                      <td align='left' width={150}><div className='bg-[#E5F3EC] text-[#029046] text-[10px] xl:px-[0.521vw] px-[8px] xl:py-[0.313vw] py-[4px] rounded-[18px] space-x-2 inline-flex items-center justify-center'><i className='pi pi-circle-fill' style={{ fontSize: '8px' }}></i><span>Approved</span></div></td>
                    </tr>
                    <tr className='text-[#344054] text-xs font-normal py-2 px-2 inline-block border-b border-[#E4E7EC]'>
                      <td align='left' width={200}>Teacher</td>
                      <td align='left' width={130}>John Mishra</td>
                      <td align='left' width={150}><div className='bg-[#E5F3EC] text-[#029046] text-[10px] xl:px-[0.521vw] px-[8px] xl:py-[0.313vw] py-[4px] rounded-[18px] space-x-2 inline-flex items-center justify-center'><i className='pi pi-circle-fill' style={{ fontSize: '8px' }}></i><span>Approved</span></div></td>
                    </tr>
                    <tr className='text-[#344054] text-xs font-normal py-2 px-2 inline-block border-b border-[#E4E7EC]'>
                      <td align='left' width={200}>EAFE Program Administrator</td>
                      <td align='left' width={130}>Alrick Barwa</td>
                      <td align='left' width={150}><div className='bg-[#FFF2E5] text-[#FF7F01] text-[10px] xl:px-[0.521vw] px-[8px] xl:py-[0.313vw] py-[4px] rounded-[18px] space-x-2 inline-flex items-center justify-center'><i className='pi pi-circle-fill' style={{ fontSize: '8px' }}></i><span>Pending for Review</span></div></td>
                    </tr>
                    <tr className='text-[#344054] text-xs font-normal py-2 px-2 inline-block'>
                      <td align='left' width={200}>Educational Services</td>
                      <td align='left' width={130}>John Mishra</td>
                      <td align='left' width={150}><div className='bg-[#FEF3F2] text-[#D92D20] text-[10px] xl:px-[0.521vw] px-[8px] xl:py-[0.313vw] py-[4px] rounded-[18px] space-x-2 inline-flex items-center justify-center'><i className='pi pi-circle-fill' style={{ fontSize: '8px' }}></i><span>Rejected</span></div></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {/*col*/}
            <div>
              <div className='xl:p-[1.042vw] p-[20px] bg-[#F5F6F7] flex items-center justify-between'>
                <div className='flex items-center space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]'>
                  <span className='gusd-file-icon w-4 h-4 inline-block'></span><span>Personal Service Agreement

                    .pdf</span>
                </div>
                <div className='text-[#113699] font-medium text-xs flex items-center gap-2 cursor-pointer' onClick={() => setStipendsFormFullScreen(true)}><span className='view_full_screen block w-[18px] h-[18px]'></span><span>View Full Screen</span></div>
              </div>

              <div className='xl:p-[1.250vw] p-[20px] bg-[#EFF0F1] rounded-md'>
                <div className='lg:h-[10.938vw] h-[242px] overflow-auto'>
                  {/* <Image src={PreviewAgreement} width={"473"} height={"612"} alt='preview-agreement' /> */}
                  <PsaPdf
                    data={{
                      'employeeName': 'Abc',
                      'employeeId': "Siddhesh",
                      'schoolName': "Privte Highschool",
                      'dateFrom': moment().format("YYYY-DD-MM"),
                      'dateTo': moment().format("YYYY-DD-MM"),
                      'subjectName': "Marathi",
                      'staffAllocation': "023",
                      'accountCharged': "accountCharge",
                      'fteUtilized': "fteUtilized"
                    }}
                  />
                </div>
              </div>
            </div>
            {/*col*/}
            <div className='custm_InputSwitch flex items-center text-[#1E3E5A] font-medium text-sm gap-2'>
              <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)} />
              <span>Add e Signature</span>
            </div>
            {/*col*/}
            <div className='grid grid-cols-3 gap-2'>
              <div className='text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'><i className='gusd-close-circle text-base'></i><span>Cancel</span></div>
              <div className='text-[#D92D20] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer' onClick={() => setRejectReport(true)}><i className='gusd-close'></i><span>Reject</span></div>
              <div className='text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer btn-deactivate' onClick={() => setReport_Approved(true)}><i className='pi pi-check'></i><span>Approve</span></div>
            </div>

          </div>
        </Sidebar>

        <Dialog header="Header" className='RejectReport' visible={RejectReport} style={{ width: '30vw' }} onHide={() => setRejectReport(false)}>
          <div className='p-[22px] space-y-[14px]'>
            {/*col*/}
            <div>
              <div className='text-[#101828] font-bold text-base -tracking-[0.36px]'>Reject Report</div>
            </div>
            {/*col*/}
            <div className='space-y-1'>
              <div className='text-[#344054] font-medium text-xs'>Enter the reason for rejection<span className="text-[red] pl-0.2">*</span></div>
              <InputText value={value} onChange={(e) => setValue(e.target.value)} placeholder='Enter the Reason for Rejection' style={{ border: '1px', borderStyle: "solid", borderRadius: '5px', borderColor: "#E4E7EC", background: "#fff", width: '100%' }} />
            </div>
            {/*col*/}
            <div className='flex items-center justify-center'>
              <div className='text-white bg-[#113699] py-2 px-4 text-center rounded-lg w-[150px] cursor-pointer' onClick={() => setRejectReport_Send(true)}>Send</div>
            </div>
            {/*col*/}
          </div>
        </Dialog>

        <Dialog header="Header" className='RejectReport' visible={RejectReport_Send} style={{ width: '30vw' }} onHide={() => setRejectReport_Send(false)}>
          <div className='p-[22px] space-y-[14px]'>
            {/*col*/}
            <div>
              <div className='text-[#101828] font-bold text-base -tracking-[0.36px]'>Reject Report</div>
            </div>
            {/*col*/}
            <div className='space-y-1'>
              <div className='text-[#249144] font-normal text-base'>Message sent successfully!</div>
              <InputText disabled value={value} onChange={(e) => setValue(e.target.value)} placeholder='Information Missing for  "David", Please review and resubmit.' style={{ border: '1px', borderStyle: "solid", borderRadius: '5px', borderColor: "#F2F4F7", background: "#F2F4F7", width: '100%' }} />
            </div>
            {/*col*/}
            <div className='flex items-center justify-center'>
              <div className='text-white bg-[#113699] py-2 px-4 text-center rounded-lg w-[150px] cursor-pointer' onClick={() => setRejectReport_Send(false)}>ok</div>
            </div>
            {/*col*/}
          </div>
        </Dialog>

        <Dialog header="Header" className='RejectReport' visible={Report_Approved} style={{ width: '30vw' }} onHide={() => setReport_Approved(false)}>
          <div className='p-[22px] space-y-[14px]'>
            <div className='flex justify-end'>
              <div className='text-[#667085] text-sm cursor-pointer' onClick={() => setReport_Approved(false)}><i className='gusd-close'></i></div>
            </div>
            <div className='flex items-center justify-center'>
              <div className='text-[#0487C8] font-medium text-lg flex items-center gap-2'><span className='right-rounded block w-[20px] h-[20px]'></span><span>Selected report was Approved</span></div>
            </div>
            {/*col*/}
            <div className='flex items-center justify-center'>
              <div className='text-[#1E3E5A] border border-[#C8C8C8] py-2 px-4 text-center rounded-lg cursor-pointer' onClick={() => setReport_Approved(false)}>Close</div>
            </div>
            {/*col*/}
          </div>
        </Dialog>

        <Sidebar className='PSAviewPopup' visible={StipendsFormFullScreen} position="right" onHide={() => setStipendsFormFullScreen(false)} style={{ width: '60vw', background: '#F5F6F7' }}>
          <div className='xl:py-[1.667vw] py-[28px] xl:px-[1.250vw] px-[20px]'>
            <div className='cursor-pointer mb-[20px]' onClick={() => setStipendsFormFullScreen(false)}><Image src={sideBarRight} alt="user" width="20" height="20" /></div>

            <div className='xl:p-[1.250vw] p-[20px] bg-[#F5F6F7] flex items-center justify-between mt-[20px]'>
              <div className='flex items-center space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]'>
                <span className='gusd-file-icon w-4 h-4 inline-block'></span><span>Personal Service Agreement

                  .pdf</span>
              </div>
              <div className='text-[#113699] font-medium text-xs flex items-center gap-2 cursor-pointer' onClick={() => setStipendsFormFullScreen(false)}><span className='Exit_Full_Screen block w-[18px] h-[18px]'></span><span>Exit Full Screen</span></div>
            </div>

            <div className='xl:p-[1.250vw] p-[20px] bg-[#F5F5F5] rounded-bl rounded-br'>
              <div className='lg:h-[25vw] overflow-auto'>
                <PsaPdf
                  data={{
                    'employeeName': 'Abc',
                    'employeeId': "Siddhesh",
                    'schoolName': "Privte Highschool",
                    'dateFrom': moment().format("YYYY-DD-MM"),
                    'dateTo': moment().format("YYYY-DD-MM"),
                    'subjectName': "Marathi",
                    'staffAllocation': "023",
                    'accountCharged': "accountCharge",
                    'fteUtilized': "fteUtilized"
                  }}
                />
              </div>
            </div>

            {/*col*/}
            <div className='custm_InputSwitch flex items-center text-[#1E3E5A] font-medium text-sm gap-2 py-[20px]'>
              <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)} />
              <span>Add e Signature</span>
            </div>
            {/*col*/}

            <div className='grid grid-cols-3 gap-2'>
              <div className='text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'><i className='gusd-close-circle text-base'></i><span>Cancel</span></div>
              <div className='text-[#D92D20] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer' onClick={() => setRejectReport(true)}><i className='gusd-close'></i><span>Reject</span></div>
              <div className='text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer btn-deactivate' onClick={() => setReport_Approved(true)}><i className='pi pi-check'></i><span>Approve</span></div>
            </div>

          </div>
        </Sidebar>

      </Layout >
       )
      }
    </ReactFullscreen>
    </>
  ) : (
    <Login sessionExpired={1} />
  );
}